/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Socialmatchsubmiterror3Inputs */



/**
* | output |
* | --- |
* | "Couldn't send the request. Please try again" |
*
* @param {Socialmatchsubmiterror3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const socialmatchsubmiterror3 = /** @type {((inputs?: Socialmatchsubmiterror3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Socialmatchsubmiterror3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Couldn't send the request. Please try again")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar la solicitud. Inténtalo de nuevo")
	return /** @type {LocalizedString} */ ("Не удалось отправить запрос. Попробуй ещё раз")
});
export { socialmatchsubmiterror3 as "socialMatchSubmitError" }